<template>
  <a-upload
    :showUploadList="false"
    action="https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos"
    @change="handleChangeEn"
  >
    <a-button type="primary" v-if="currentSubtitle">更换</a-button>
    <a-button v-else> <a-icon type="upload" /> 上传 </a-button>
  </a-upload>
</template>

<script>
import {updateGather} from "@/api/video/gather";

export default {
  name: "gatherUploadBtn",
  props:{
    customInfo:{
      type:Object,
    },
    customIndex:{
      type:Number
    },
    customType:{
      type:Number
    }
  },
  computed: {
    subtitleField() {
      // 自定义字段映射
      const map = {
        1: 'subtitleCn',
        2: 'subtitleEn',
        3: 'subtitleJa',

        4: 'subtitleId',
        5: 'subtitlePt',
        6: 'subtitleEs',
      };
      return map[this.customType];
    },
    currentSubtitle() {
      return this.customInfo?.[this.subtitleField];
    }
  },
  methods:{
    handleChangeEn(info) {
      console.log(info)
      var fileType = info.file.name;
      if(this.customType == 1) {
        //中文
        this.customInfo.subtitleCn =  info.file.response.data.mediaUrl
        // this.$set(this.list[this.signleIndex],'subtitleCn',info.file.response.data.mediaUrl);
        updateGather(this.customInfo).then(res => {
          this.$emit("change")
        })

      }

      if(this.customType == 2) {
        //英文
        this.customInfo.subtitleEn =  info.file.response.data.mediaUrl;

        updateGather(this.customInfo).then(res => {
          this.$emit("change")
        })
      }

      if(this.customType == 3) {
        //日语
        this.customInfo.subtitleJa =  info.file.response.data.mediaUrl;

        updateGather(this.customInfo).then(res => {
          this.$emit("change")
        })
      }

      if(this.customType == 4) {
        //印尼
        this.customInfo.subtitleId =  info.file.response.data.mediaUrl;

        updateGather(this.customInfo).then(res => {
          this.$emit("change")
        })
      }

      if(this.customType == 5) {
        //葡语
        this.customInfo.subtitlePt =  info.file.response.data.mediaUrl;

        updateGather(this.customInfo).then(res => {
          this.$emit("change")
        })
      }

      if(this.customType == 6) {
        //西语
        this.customInfo.subtitleEs =  info.file.response.data.mediaUrl;

        updateGather(this.customInfo).then(res => {
          this.$emit("change")
        })
      }
    },
  }
}
</script>

<style scoped>

</style>